import { defineFetch } from 'resift';

const makeGetSourceGroups = defineFetch({
  displayName: 'Get Source Groups',
  make: sourceId => ({
    request: q => ({ http }) =>
      http({
        method: 'GET',
        route: `/sources/${sourceId}/groups`,
        query: {
          q,
        },
      }),
  }),
});

export default makeGetSourceGroups;
